import React, { useState } from 'react'
import InitialStep from 'components/buy/Engraving/Front/InitialStep'
import Pattern from 'components/buy/Engraving/Front/Pattern'
import MiniIcon from 'components/buy/Engraving/Front/MiniIcon'
import Text from 'components/buy/Engraving/Text'

const Front = () => {
  const [step, setStep] = useState('initialstep')

  if (step.toLowerCase() === 'initialstep') return <InitialStep setStep={setStep} />
  if (step.toLowerCase() === 'pattern') return <Pattern setStep={setStep} />
  if (step.toLowerCase() === 'miniicon') return <MiniIcon setStep={setStep} />
  if (step.toLowerCase() === 'text') return <Text item="front" setStep={setStep} />
  return <InitialStep setStep={setStep} />
}

export default Front
